import React, { useState, useEffect } from 'react';
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
} from '@mui/material';
import TableListHeader from './TableListHeader';
import TableListItem from './TableListItem';
import CustomPagination from '../../Pagination';

const EquipmentTableView = ({ data, setOpenDialog, searchQuery }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage, setProductsPerPage] = useState(10);

  const filteredData = data.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / productsPerPage);
  const indexOfLast = currentPage * productsPerPage;
  const indexOfFirst = indexOfLast - productsPerPage;
  const currentProducts = filteredData.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  return (
    <TableContainer
      component={Paper}
      elevation={0}
  sx={{
    border: '0.5px solid rgba(181, 181, 181, 1)',
    boxShadow: 'none',
    ml: '1rem',
    width: '95%',
    borderRadius: '8px',

    //  SCROLL SETTINGS
    maxHeight: '60vh',
    overflowY: 'auto',
  }}
    >
      {/*  ONE table lives here */}<Table
  stickyHeader
  sx={{
    width: '100%',
    tableLayout: 'fixed',
  }}
>

        
        <TableListHeader />

        <TableBody>
          {currentProducts.map((product) => (
            <TableListItem
              key={product.id}
              product={product}
              searchQuery={searchQuery}
            />
          ))}
        </TableBody>

      </Table>

      {/* Pagination OUTSIDE the table */}
      <CustomPagination
        count={totalPages}
        page={currentPage}
        onChange={(e, value) => setCurrentPage(value)}
        productsPerPage={productsPerPage}
        setProductsPerPage={setProductsPerPage}
      />
    </TableContainer>
  );
};

export default EquipmentTableView;
